export const hasHumanReferral = conversation =>
  Boolean(
    conversation?.priority === 'urgent' ||
      conversation?.team_id ||
      conversation?.assignee_id ||
      conversation?.meta?.team?.id ||
      conversation?.meta?.assignee?.id
  );
